<template>
  <div class="new-task-modal addAndColumn">
    <el-dialog
      :visible.sync="cpNewModalVisible"
      :width="defaultWidth"
      :before-close="handleClose"
      @closed="handleClose"
      :close-on-click-modal="closeonclickmodal"
      v-el-drag-dialog
    >
      <div slot="title" class="task-modal-title">
        <span class="modal-title-span">{{ modalTitle }}</span>
      </div>
      <div>
        <el-form
          @validate="validateValue"
          :show-message="false"
          :model="ruleForm"
          :rules="rules"
          ref="ruleFormeOne"
          label-width="86px"
          class="addAndUpdate"
        >
          <div class="formOne-forms">
            <div class="forms-one" style="margin-top: 27px">
              <div class="one-list my-from-label">
                <el-form-item
                  label="名称"
                  prop="name"
                  :rules="{
                    required: true,
                    message: `请输入名称`,
                    trigger: 'blur',
                  }"
                >
                  <el-input
                    class="list-input"
                    :maxlength="6"
                    v-model.trim="ruleForm.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="链接"
                  prop="url"
                >
                  <el-input
                    class="list-input"
                    :maxlength="1000"
                    v-model.trim="ruleForm.url"
                    placeholder="请输入完整的http(s)"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="顺序"
                  prop="sort"
                  :rules="{
                    required: true,
                    message: `请输入顺序`,
                    trigger: 'blur',
                  }"
                >
                  <el-input-number
                    class="list-input baseData-input-number"
                    :controls="false"
                    v-model="ruleForm.sort"
                    :min="1"
                    :max="99"
                    step-strictly
                    placeholder="请输入正整数"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="使用角色" prop="viewPermission">
                  <!-- <el-radio-group v-model="ruleForm.openAll">
                  <el-radio label="1">展示</el-radio>
                  <el-radio label="2">隐藏</el-radio>
                </el-radio-group> -->
                  <template>
                    <el-tag
                      style="margin: 0 4px"
                      v-for="tag in roleTags"
                      :key="tag.id"
                      @close="handleRoleClose(tag)"
                      closable
                      >{{ tag.name }}</el-tag
                    >
                    <el-button
                      style="height: 24px"
                      type="default"
                      icon="el-icon-plus"
                      @click="addTags('role')"
                      >新增</el-button
                    >
                  </template>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="member-modal-footer">
        <el-button class="modal-footer-two" @click="closeModal">取消</el-button>
        <el-button class="modal-footer-two" type="primary" @click="agreeAdd"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      class="serviceListTreeMy"
      title="新增授权角色"
      :visible.sync="roleTreeDialogVisible"
      :close-on-click-modal="false"
      width="30%"
      v-el-drag-dialog
    >
    <div class="dialogRoleChange" id="dialogRoleTree">
      <el-tree
        :data="roleTree"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="roleTree"
        highlight-current
        :props="{
          children: 'children',
          label: 'roleName',
        }"
      ></el-tree>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleTreeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getCheckedKeys('roleTree')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { setStore, getStore } from "@/utils/store";
export default {
  name: "hignModal",
  props: {
    showAgree: {
      type: Boolean,
      default: false,
    },
    defaultWidth: {
      type: String,
      default: "576px",
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    isOneBtn: {
      type: Boolean,
      default: false,
    },
    newModalVisible: {
      type: Boolean,
      default: false,
    },
    agreeBtn: {
      type: String,
      default: "确定",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    //是否点击空白处关闭弹窗
    closeonclickmodal: {
      type: Boolean,
      default: false,
    },
    isChangelastStep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.roleTags.length<1) {
        callback(new Error("请选择使用角色"));
      } else {
        // if (this.ruleForm.checkPass !== '') {
        // this.$refs.ruleForm.validateField('checkPass');
        // }
        callback();
      }
    };
    return {
      cpNewModalVisible: this.newModalVisible,
      countNum: 1, //用于显示第一个错误
      rules: {
        fileList_P: [{ required: true, message: "请输入", trigger: "blur" }],
        viewPermission: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        url:[{ required: true, message: "请输入链接地址", trigger: "blur" }, { type: "string", pattern: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/, message: "请输入正确格式的链接地址", trigger: "blur" }]
      },
      ruleForm: {
        id: "",
        name: "", //名称
        url: "", //链接
        sort: undefined, //排序
        status: 1, //排序
        viewPermission: "", // 标签
      },
      roleTags: [], // 角色标签
      roleTreeDialogVisible: false, // role弹窗
      roleTree: [], //角色列表
      modalTitle: "新增", //表头名称
      rowData: {},
    };
  },
  methods: {
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //表单重置
    Reset() {
      let result = getStore({ name: "AlumniOPenRowData", type: "session" });
      console.log(result);
      if (result != null) {
        this.rowData = result;
        this.modalTitle = "编辑";
        this.ruleForm = {
          id: this.rowData.id,
          name: this.rowData.name, //名称
          url: this.rowData.url, //链接
          sort: this.rowData.sort, //排序
          status: this.rowData.status, //排序
          viewPermission: this.rowData.viewPermission, // 标签
        };
      } else {
        this.modalTitle = "新增";
        this.rowData = {};
        this.ruleForm = {
          id: "",
          name: "", //名称
          url: "", //链接
          sort: undefined, //排序
          status: 1, //排序
          viewPermission: "", // 标签
        };
        this.roleTags = [];
      }
      this.getRolelist(); // 获取使用角色

      //   this.$nextTick(() => {
      //     this.itemDetail();
      //   });
    },
    //================================================下方新增角色弹框,上方为新增栏目弹框
    async getRolelist() {
      try {
        const res2 = await this.$store.dispatch("getServiceRoleList");
        if (res2.data.status === 1000) {
          const { result } = res2.data;
          this.roleTree = result;
        }
        // debugger
        let childrenList = []; // 整理角色列表 去除一级 只留二级数据
        this.roleTags = [];
        this.roleTree.forEach((element) => {
          element.children.forEach((ele) => {
            childrenList.push(ele);
          });
        });
        if (this.rowData && this.rowData.viewPermission) {
          this.rowData.viewPermission.split(",").forEach((element) => {
            let role = childrenList.map((item) => {
              if (item.roleId === element) {
                return {
                  id: item.roleId,
                  name: item.roleName,
                };
              }
            });
            role = role.filter((item) => item);
            role.forEach((ele) => this.roleTags.push(ele));
            console.log(this.roleTags);
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleRoleClose(tag) {
      console.log(tag);
      const { roleTags } = this;
      this.roleTags = roleTags.filter((item) => item !== tag);
    },
    addTags(type) {
      this.roleTreeDialogVisible = true;
      this.roleOrlabel = true;
      if (this.roleTags.length > 0) {
        const keys = this.roleTags.map((item) => item.id);
        // console.log(keys)
        this.$nextTick(() => {
          this.$refs.roleTree.setCheckedKeys(keys);
        });
      } else {
        this.$nextTick(() => {
            this.$refs.roleTree.setCheckedKeys([]);
        })
      }
      this.$nextTick(() => {
        document.getElementById('dialogRoleTree').scrollTop = 0
      })
    },
    getCheckedKeys(refName) {
      const getNode = this.$refs[refName].getCheckedNodes();
      if (this.roleOrlabel) {
        const selectArr = getNode.map((item) => {
          if (item.roleId) {
            return {
              name: item.roleName,
              id: item.roleId,
            };
          }
        });
        this.roleTags = selectArr.filter((item) => item);
        this.roleTreeDialogVisible = false;
      }
    },
    //=======================================================之前的方法
    // 弹窗关闭触发
    handleClose(done) {
      // console.log(111)
      if (this.isChangelastStep) {
        if (done) {
          return done();
        }
      }
      this.$emit("closeNewTask");
    },
    closedModal() {
      if (this.isChangelastStep) {
        return this.$emit("cancelEvent");
      }
      this.$emit("closeNewTask");
    },
    // 确认
    agreeAdd() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleFormeOne.validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            return this.commit();
          } else {
            return false;
          }
        });
      });
    },
    commit() {
        if (this.roleTags.length<1) {
           return this.$message.error('请选择使用角色')
        }
      this.ruleForm.viewPermission = this.roleTags
        .map((item) => item.id)
        .join(",");
    //   this.ruleForm.states = 1;
      if (this.modalTitle == "新增") {
        this.$emit("addNewTask", this.ruleForm);
      } else {
        this.$emit("updateClu", this.ruleForm);
      }
    },
    // 上一步
    lastClick() {
      this.$emit("LastStep");
    },
    // 取消
    closeModal() {
      this.$emit("closeNewTask");
    },
  },
  watch: {
    newModalVisible() {
      this.cpNewModalVisible = this.newModalVisible;
      this.$refs.ruleFormeOne.resetFields();
    },
    roleTreeDialogVisible(val) {
        if (val) {
        }
    }

  },
};
</script>

<style lang="scss">
.addAndColumn{
    .el-checkbox{
        width: 16px;
    }
    .serviceListTreeMy {
        .el-dialog__header {
            border-bottom: 1px solid #d9d9d9;
            height: 44px;
        }
        .el-dialog__footer {
            border-top: 1px solid #d9d9d9;
        }
        .el-dialog__body {
            padding: 0;
            height: auto !important;
            overflow-y: hidden !important;
            .dialogRoleChange {
                padding: 16px;
                height: 276px;
                overflow-y: auto;
            }
            .dialogRoleChange::-webkit-scrollbar {
                width: 8px;
                height: 8px;
                background-color: #fff;
                border-radius: 20px;
            }
            .dialogRoleChange::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background-color: #d4d4d7;
            }
        }
    }
}
.new-task-modal {
  .baseData-input-number {
    .el-input__inner {
      text-align: left;
    }
  }
  .el-dialog__header {
    border-bottom: 1px solid #d4d4d7;
    padding: 11px 16px;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .task-modal-title {
      .modal-title-icon {
        font-size: 12px;
      }
      .modal-title-span {
        font-size: 12px;
        color: #2e4057;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    height: 276px;
    padding: 16px;
    text-align: center;
    overflow-y: auto;
    .el-form-item {
      display: inline-block;
      margin-bottom: 8px;
    }
    .new-task-input {
      width: 316px;
    }
    .new-task-textarea {
      width: 316px;
      textarea {
        height: 102px;
      }
    }
    .addAndUpdate {
      .my-from-label {
        .el-form-item {
          display: block;
          text-align: left;
          .el-input--small .el-input__inner {
            width: 316px;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #d4d4d7;
    padding: 16px;
    .task-modal-footer {
      font-size: 0;
      .el-button {
        // padding: 0 !important;
        margin-left: 8px !important;
      }
      .modal-footer-two {
        // width: 48px;
        height: 28px;
      }
      .modal-footer-four {
        // width: 72px;
        height: 28px;
      }
    }
  }
}
</style>
